// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"374":"tenant-discovery","951":"tenant-showcase"}[chunkId] || chunkId) + "." + {"57":"fc258b98","109":"98022e65","148":"2d337294","240":"91b7c736","280":"8de06c95","374":"c1e599cd","537":"20a3b0da","632":"830e4c64","795":"0658b6b1","951":"328658c3"}[chunkId] + ".chunk.js";
};